<div>
	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Food details'">
		<ui-text-form-field
			[title]="'Food name'"
			[isRequired]="true"
			[valueAsSignal]="form.name"
			[maxLength]="150"
			[isInDialog]="isInDialog()"
		></ui-text-form-field>

		<ui-text-area-form-field
			class="push-top-md"
			[title]="'Notes'"
			[valueAsSignal]="form.notes"
			[maxLength]="2000"
			[isInDialog]="isInDialog()"
		></ui-text-area-form-field>
	</lib-card>

	<lib-card [isInDialog]="isInDialog()" [isForm]="true" [title]="'Images'" class="push-top-md">
		<ui-file-form-field
			[validation]="'images'"
			[isRequired]="false"
			[maxFiles]="1"
			[uploadFunction]="uploadFunction"
			[imageCrop]="foodImageCrop"
			[valueAsSignal]="form.images"
			[imageCrop]="defaultSquareImageCrop"
			[enableImageGallery]="true"
			(valueChange)="handleUploadImage($event)"
			[isInDialog]="isInDialog()"
			class="push-top-md"
		></ui-file-form-field>
	</lib-card>

	<lib-card
		[isInDialog]="isInDialog()"
		[isForm]="true"
		[title]="'Nutrition'"
		[subtitle]="'Per 100 grams'"
		class="push-top-md"
	>
		<div [libFlexRow]="true" [libFlexRowGap]="'24px'">
			@for (nutritionField of nutritionFields(); track nutritionField.title) {
			<div libFlexColumn [style.width]="calculateFlexWidth(isMobileView() ? 2 : 3, 24)">
				<ui-number-form-field
					[title]="nutritionField.title"
					[isRequired]="nutritionField.required"
					[valueAsSignal]="nutritionField.valueAsSignal"
					[minValue]="nutritionField.minValue"
					[maxValue]="nutritionField.maxValue"
					[isInDialog]="isInDialog()"
					[maxValue]="1000"
				></ui-number-form-field>
			</div>
			}
		</div>
	</lib-card>

	<ui-form-save-button
		class="push-top-md"
		[isInDialog]="isInDialog()"
		[title]="isEditForm() ? 'Edit' : 'Create'"
		[saveHandler]="saveHandler()"
		[logHandler]="formLogHandler()"
	></ui-form-save-button>
</div>
